import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Icon } from 'appSrc/components/UI';
import { showModal } from 'appSrc/redux/actions';
import style from './styles/style.module.css';

class AddListCard extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className={ `${ style.listCard } ${ style.addCard }` }
            onClick={ this.props.showNewListModal }
            style={ {
                cursor: 'pointer',
                ...this.props.style,
            } } >
                <div className={ style.makeNewListItem } >
                    <Icon icon='plus-colored' size={ 88 } />
                    <p>Add New List</p>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showNewListModal: () => {
            dispatch( showModal( 'listCreationModal' ) );
        },
    };
};


export default connect( null, mapDispatchToProps )( AddListCard );
